export default __webpack_public_path__ + "static/media/objects-feeling-introversion.c48f9433.png";